import { t } from 'i18next';
import { object, string } from 'yup';

const getSchema = () =>
  object({
    district: object()
      .shape({
        value: string(),
        label: string(),
      })
      .nullable()
      .required(
        t('validationMessages.requiredField', {
          fieldName: 'District',
        })
      )
      .default(null),
    username: string()
      .trim()
      .required(
        t('validationMessages.requiredField', {
          fieldName: 'Username',
        })
      )
      .default(''),
    password: string()
      .trim()
      .required(
        t('validationMessages.requiredField', {
          fieldName: 'Password',
        })
      )
      .default(''),
  });

export const getValidation = () => ({
  validationSchema: getSchema(),
  defaultValues: getSchema().cast({}),
});
